module.exports = __webpack_public_path__ + "static/media/samgatha.7e676b2e.png";